module.exports={
	"withCountryName": [{
			"featureType": "all",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry",
			"stylers": [{
				"color": "#8b95ae"
			}]
		},
		{
			"featureType": "administrative",
			"elementType": "labels",
			"stylers": [{
				"visibility": "on"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "geometry.stroke",
			"stylers": [{
					"visibility": "on"
				},
				{
					"color": "#d0d0d0"
				},
				{
					"weight": "1.00"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels",
			"stylers": [{
				"visibility": "on"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels.text.fill",
			"stylers": [{
				"color": "#5a6771"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels.text.stroke",
			"stylers": [{
					"gamma": "1.00"
				},
				{
					"weight": "0.50"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "geometry.stroke",
			"stylers": [{
					"visibility": "off"
				},
				{
					"weight": "1.87"
				},
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.locality",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.neighborhood",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.land_parcel",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "all",
			"stylers": [{
				"color": "#ffffff"
			}]
		},
		{
			"featureType": "landscape.natural.landcover",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f9f9f9"
			}]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f6f6f6"
			}]
		},
		{
			"featureType": "poi",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f8f8f8"
			}]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "water",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#b8cadb"
			}]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		}
	],
	"withoutCountryName": [{
			"featureType": "all",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry",
			"stylers": [{
				"color": "#8b95ae"
			}]
		},
		{
			"featureType": "administrative",
			"elementType": "labels",
			"stylers": [{
				"visibility": "on"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "geometry.stroke",
			"stylers": [{
					"visibility": "on"
				},
				{
					"color": "#d0d0d0"
				},
				{
					"weight": "1.00"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels.text.fill",
			"stylers": [{
				"color": "#5a6771"
			}]
		},
		{
			"featureType": "administrative.country",
			"elementType": "labels.text.stroke",
			"stylers": [{
					"gamma": "1.00"
				},
				{
					"weight": "0.50"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "geometry.stroke",
			"stylers": [{
					"visibility": "off"
				},
				{
					"weight": "1.87"
				},
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "administrative.province",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.locality",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.neighborhood",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "administrative.land_parcel",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "all",
			"stylers": [{
				"color": "#ffffff"
			}]
		},
		{
			"featureType": "landscape.natural.landcover",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f9f9f9"
			}]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f6f6f6"
			}]
		},
		{
			"featureType": "poi",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#f8f8f8"
			}]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [{
				"visibility": "off"
			}]
		},
		{
			"featureType": "water",
			"elementType": "geometry.fill",
			"stylers": [{
				"color": "#b8cadb"
			}]
		},
		{
			"featureType": "water",
			"elementType": "labels",
			"stylers": [{
				"visibility": "off"
			}]
		}
	]
}
